import React from "react";
import logo from "../../assets/images/cta-logo.png"
import "./CtaSection.css"

const CtaSection: React.FC = () => {
    return (
        <section className="cta-section">
            <div className="container" id="cta-section-container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="cta-content">
                            <h2>MOJE HODNOTY A VÍZIA PRE PÚCHOV</h2>
                            <a href="/program" className="theme-btn">Otvorenosť a dialóg</a>
                            <a href="/program" className="theme-btn-s3">Zodpovedné a transparentné hospodárenie</a>
                            <a href="/program" className="theme-btn">Doprava a parkovanie pre ľudí</a>
                            <a href="/program" className="theme-btn-s3">Podpora rodín a zdravého životného štýlu</a>
                            <a href="/program" className="theme-btn">Úcta k seniorom a oživenie centra</a>
                            <a href="/program" className="theme-btn-s3">Partnerstvo s domácimi podnikateľmi</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CtaSection;